/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LearnMoreAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaIconArrowDown from 'DesignSystem/Svgs/TysiaIconArrowDown/index'
import TysiaIconArrowUp from 'DesignSystem/Svgs/TysiaIconArrowUp/index'



/** @type {import('Simple/types.js').View} */
export default function LearnMoreAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/LearnMoreAction",
  onClick,
  value
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 marginTop={dtSpaceXs}
 marginLeft={-14}
 type="ghost"
 onClick={onClick}
>
{childProps => (
<React.Fragment>
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Learn more"
/>
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={value}>
<TysiaIconArrowUp
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowUp`}
/>
</fromFlow.When>
<fromFlow.When is={!value}>
<TysiaIconArrowDown
{...childProps}
  viewPath={`${viewPath}/TysiaIconArrowDown`}
/>
</fromFlow.When>
</React.Fragment>
)}
</TysiaButtonIcon>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}